import React, { useEffect, useMemo, useState } from "react";
import Menu from "../components/menu";
import Footer from "../components/footer";
import api from "../config/axios";
import ImgBannerTournoi from "../components/imgBannerTournoi";
import VignetteTournoi from "../components/imgVignetteTournoi";
import iconeTennis from '../assets/images/icone-tennis.png';
import iconeCalendar from '../assets/images/icone-calendar.png';
import TournoiCard from "../components/cardTournoi";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../styles/calendar.css';

interface TTournoi {
    tournoiId: number;
    tournoiLib: string;
    tournoiDateDebut: string;
    tournoiDateFin: string;
    clubId: number;
    categorieId: number;
    epreuveId: number;
    ligueId: number;
    dateAjout: string;
}

interface TClub {
    clubId: number;
    clubLib: string;
    infosInscription: string;
    ligues: TLigue[];
}

interface TCategorie {
    categorieId: number;
    categorieLib: string;
}

interface TLigue {
  ligueId: number;
  ligueLib: string;
}

interface TEpreuve {
    epreuveId: number;
    epreuveLib: string;
}

interface Filters {
  clubId: string;
  categorieIds: number[];
  epreuveId: string;
  ligueId: string;
  date: string;
  favoriteLigue: boolean;
}

interface TUserLigue {
  //userId: number;
  ligueId: number;
  //ligueLib: string;
}
const Tournois: React.FC = () => {
  
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [tournois, setTournois] = useState<TTournoi[]>([]);
  const [clubs, setClubs] = useState<TClub[]>([]);
  const [categories, setCategories] = useState<TCategorie[]>([]);
  const [epreuves, setEpreuves] = useState<TEpreuve[]>([]);
  const [ligues, setLigues] = useState<TLigue[]>([]);
  const [favoriteLigues, setFavoriteLigues] = useState<TUserLigue[]>([]);
  const [filteredClubs, setFilteredClubs] = useState<TClub[]>([]);

    const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const [filters, setFilters] = useState<Filters>({
    clubId: "",
    categorieIds: [],  // Initialize as empty array
    epreuveId: "",
    ligueId: "",
    date: "",
    favoriteLigue: false
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
  const tournoisPerPage = 12;


  useEffect(() => {
    const fetchData = async () => {
      try {
        const [tournoiRes, clubRes, categorieRes, epreuveRes, ligueRes] = await Promise.all([
          api.get("/tournoi"),
          api.get("/club"),
          api.get("/categorie"),
          api.get("/epreuve"),
          api.get("/ligue"),          
        ]);        
        setTournois(tournoiRes.data);
        setClubs(clubRes.data);
        setFilteredClubs(clubRes.data); // Initialize with all clubs
        setCategories(categorieRes.data);
        setEpreuves(epreuveRes.data);
        setLigues(ligueRes.data);
    
      } catch (error) {
        console.error("Erreur lors du chargement des données :", error);
      }
    };
    fetchData();

    const token = sessionStorage.getItem('accessToken'); // Lire depuis sessionStorage

    setIsLoggedIn(!!token);
    
  }, []);  


// Add useEffect to filter clubs when ligue changes
useEffect(() => {
  if (filters.ligueId) {
    console.log(clubs);
    const filteredClubs = clubs.filter(club => 
      club.ligues && 
      club.ligues.some(ligue => ligue.ligueId === Number(filters.ligueId))
    );
    setFilteredClubs(filteredClubs);
    // Reset club selection when changing ligue
    setFilters(prev => ({ ...prev, clubId: '' }));
  } else {
    setFilteredClubs(clubs);
  }
}, [filters.ligueId, clubs]);

  // Add effect to fetch favorite leagues
  useEffect(() => {
    
    const token = sessionStorage.getItem('accessToken'); // Lire depuis sessionStorage
    setIsLoggedIn(!!token);    

    const fetchFavoriteLigues = async () => {

      try {
        
        if(isLoggedIn) {          
          
          const response = await api.get('/userligue');
          
          if (response.data) {            

            const favoriteLigues: TUserLigue[] = response.data.map((item: { ligue: { ligueId: number } }) => ({ ligueId: item.ligue.ligueId }));
            
            setFavoriteLigues(favoriteLigues);            

          }
        }
      } catch (error) {
        console.error('Error fetching favorite leagues:', error);        
      }
    };

    fetchFavoriteLigues();
  }, [isLoggedIn]);

  const handleFilterChange = async (filterName: string, value: string | number[] | boolean) => {
    
    const newFilters = { ...filters, [filterName]: value };

    setFilters(newFilters);
    console.log(newFilters);
     // Reset to first page when filtering
     setCurrentPage(1);
    
    try {
      const params = new URLSearchParams();
      Object.entries(newFilters).forEach(([key, val]) => {
          if (key === 'categorieIds' && Array.isArray(val)) {
              // Handle array of category IDs
              if (val.length > 0) {
                  val.forEach((catId: number) => params.append('categorieId[]', catId.toString()));
              }
          } else if (val) {
              params.append(key, val.toString());
          }
      });
                
        const response = await api.get(`/tournoi/filter?${params.toString()}`);      
        setTournois(response.data);
        

       /* TO DO : A REVOIR si besoin d'améliorer les performances       
       setlstTournois(response.data);

        const filtered = tournois.filter(tournoi => {
      
          const isFavoriteLigue = !filters.favoriteLigue || !isLoggedIn 
          ? true
          : favoriteLigues.some(fav => fav.ligueId === tournoi.ligueId);
  
        const matchesClub = filters.clubId ? tournoi.clubId === Number(filters.clubId) : true;    
        
        const matchesLigues = filters.ligueId ? tournoi.ligueId === Number(filters.ligueId) : true;
  
        const matchesCategories = selectedCategories.length > 0 
          ? selectedCategories.includes(tournoi.categorieId) 
          : true;
  
        const matchesEpreuve = filters.epreuveId
          ? tournoi.epreuveId === Number(filters.epreuveId)
          : true;
  
        const matchesDate = filters.date
          ? new Date(tournoi.tournoiDateDebut) >= new Date(filters.date)
          : true;
                  
  
        return isFavoriteLigue && matchesClub && matchesLigues && matchesCategories && matchesEpreuve && matchesDate;
  
      });  

      setTournois(filtered);*/

    } catch (error) {
        console.error("Erreur lors du filtrage :", error);
    }
};
    
const handleCategoryChange = async (categorieId: number) => {
    const newSelectedCategories = selectedCategories.includes(categorieId)
        ? selectedCategories.filter(id => id !== categorieId)
        : [...selectedCategories, categorieId];
    
    setSelectedCategories(newSelectedCategories);
    
    // Update filters and trigger API call
    await handleFilterChange('categorieIds', newSelectedCategories);
};

const filteredTournois = useMemo(() => {          

    const filtered = tournois.filter(tournoi => {
      
        const isFavoriteLigue = !filters.favoriteLigue || !isLoggedIn 
        ? true
        : favoriteLigues.some(fav => fav.ligueId === tournoi.ligueId);

      const matchesClub = filters.clubId ? tournoi.clubId === Number(filters.clubId) : true;    
      
      const matchesLigues = filters.ligueId ? tournoi.ligueId === Number(filters.ligueId) : true;

      const matchesCategories = selectedCategories.length > 0 
        ? selectedCategories.includes(tournoi.categorieId) 
        : true;

      const matchesEpreuve = filters.epreuveId
        ? tournoi.epreuveId === Number(filters.epreuveId)
        : true;

      const matchesDate = filters.date
        ? new Date(tournoi.tournoiDateDebut) >= new Date(filters.date)
        : true;
                

      return isFavoriteLigue && matchesClub && matchesLigues && matchesCategories && matchesEpreuve && matchesDate;

    });    

    return filtered;
  }, [tournois]);


  const indexOfLastTournoi = currentPage * tournoisPerPage;
  const indexOfFirstTournoi = indexOfLastTournoi - tournoisPerPage;

  const currentTournois = useMemo(() => {
  
    const indexOfLastTournoi = currentPage * tournoisPerPage;
    const indexOfFirstTournoi = indexOfLastTournoi - tournoisPerPage;
    
    return filteredTournois.slice(indexOfFirstTournoi, indexOfLastTournoi);

  }, [filteredTournois, currentPage, tournoisPerPage]);


  return (
    <div>
      <Menu />

      {/* Bannière Hero Moderne */}
      <div className="relative bg-gradient-to-br from-orange-500 via-orange-600 to-red-600 overflow-hidden">
        {/* Background decoratif */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full -mr-48 -mt-48"></div>
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-white rounded-full -ml-40 -mb-40"></div>
        </div>

        {/* Contenu */}
        <div className="relative z-10 max-w-6xl mx-auto px-4 py-12 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Colonne gauche - Texte */}
            <div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Trouvez un <span className="text-orange-100">tournoi</span> dans votre région
              </h1>
              <p className="text-lg md:text-xl text-orange-50 mb-8 leading-relaxed">
                Découvrez tous les tournois de padel en France, inscrivez-vous et participez à des compétitions passionnantes près de chez vous.
              </p>
              <a 
                href="#tournaments" 
                className="inline-block bg-white text-orange-600 px-8 py-4 rounded-xl font-bold hover:bg-orange-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                Découvrir les tournois
              </a>
            </div>

            {/* Colonne droite - Illustration */}
            <div className="hidden md:block">
              <ImgBannerTournoi />
            </div>
          </div>
        </div>
      </div>
          
      <div className="flex flex-col md:flex-row gap-6 p-4 py-8">
        {/* Sidebar Filters */}
        <div className="flex flex-col w-full md:w-1/4">
        <div className="md:hidden p-2 mb-2">         
        <button 
            onClick={() => setIsFilterVisible(!isFilterVisible)}
            className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white px-4 py-3 rounded-xl font-bold hover:from-orange-600 hover:to-orange-700 transition-all"
          >
            {isFilterVisible ? '✕ Masquer les filtres' : '⊕ Afficher les filtres'}
          </button>          
        </div>        
        
        <div className={`
          w-full bg-base-100 
          ${isFilterVisible ? 'block' : 'hidden'} 
          md:block
        `}>
            {/* Calendrier */}
            <div className="bg-white rounded-2xl shadow-lg p-4 mb-4">
              <h3 className="text-lg font-semibold mb-4 text-gray-900">À partir de :</h3>
              <div className="calendar-container">
                <Calendar
                  onChange={(date) => {
              const selectedDate = Array.isArray(date) ? date[0] : date;
              setSelectedDate(selectedDate);
              if (selectedDate) {
                const year = selectedDate.getFullYear();
                const month = String(selectedDate.getMonth() + 1).padStart(2, '0'); 
                const day = String(selectedDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;
                handleFilterChange('date', formattedDate);
              }
                  }}
                  value={selectedDate}
                  minDate={new Date()}
                  className="w-full rounded shadow-sm"
                  tileClassName={({ date, view }) => 
              view === 'month' && date.toDateString() === (selectedDate?.toDateString() || '') 
              ? 'bg-orange-500 text-white rounded-full' 
              : null
                  }
                />                
              </div>     
            </div>
            
            {/* Filtres */}
            <div className="bg-white rounded-2xl shadow-lg p-4 sticky top-4">
                           
              <h3 className="text-lg font-semibold mb-4 text-gray-900">Ligues</h3>
              <select
                  name="ligueId"
                  onChange={(e) => handleFilterChange(e.target.name, e.target.value)}
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none mb-4"
              >
                  <option value="">Toutes les ligues</option>
                  {ligues.map((l) => (
                      <option key={l.ligueId} value={l.ligueId}>
                          {l.ligueLib}
                      </option>
                  ))}
              </select>

              <h3 className="text-lg font-semibold mb-4 text-gray-900">Clubs</h3>                
              <select
                  name="clubId"
                  onChange={(e) => handleFilterChange(e.target.name, e.target.value)}
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none mb-4"
              >
                  <option value="">Tous les clubs</option>
                  {filteredClubs.map((club) => (
                      <option key={club.clubId} value={club.clubId}>
                          {club.clubLib}
                      </option>
                  ))}
              </select>
                

                {isLoggedIn && (
                  <label className="flex items-center space-x-2 mb-4 p-3 bg-orange-50 rounded-xl border border-orange-200">
                  <input
                    type="checkbox"
                    name="favoriteLigue"
                    onChange={(e) => handleFilterChange(e.target.name, e.target.checked)}
                    className="checkbox checkbox-warning"
                  />
                <span className="text-sm font-medium text-orange-900">Ligues favorites</span>
              </label>
                )}
                
                <h3 className="text-lg font-semibold mb-4 text-gray-900">Catégories</h3>
                <div className="space-y-2 mb-4">
                    {categories.map((categorie) => (
                        <div key={categorie.categorieId} className="flex items-center p-2 hover:bg-gray-50 rounded-lg">
                            <input
                                type="checkbox"
                                id={`categorie-${categorie.categorieId}`}
                                checked={selectedCategories.includes(categorie.categorieId)}
                                onChange={() => handleCategoryChange(categorie.categorieId)}
                                className="mr-3 w-4 h-4 accent-orange-500 rounded"
                            />
                            <label htmlFor={`categorie-${categorie.categorieId}`} className="text-sm text-gray-700 cursor-pointer">
                                {categorie.categorieLib}
                            </label>
                        </div>
                    ))}
                </div>

                <h3 className="text-lg font-semibold mb-4 text-gray-900">Épreuves</h3>
                <select
                    name="epreuveId"
                    onChange={(e) => handleFilterChange(e.target.name, e.target.value)}
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none"
                >
                    <option value="">Toutes les épreuves</option>
                    {epreuves.map((ep) => (
                        <option key={ep.epreuveId} value={ep.epreuveId}>
                            {ep.epreuveLib}
                        </option>
                    ))}
                </select>

            </div>
            </div>
        </div>

        {/* Tournament Cards Grid */}
        <div className="w-full md:w-3/4">
            <div className="mb-8">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
                {filteredTournois.length} <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-red-600">tournois</span>
              </h2>
              <p className="text-gray-600 text-sm md:text-base">
                {filters.clubId && (
                  <>pour le club {clubs.find(club => club.clubId === Number(filters.clubId))?.clubLib} • </>
                )}
                {Number(filters.ligueId) > 0 ? (
                  <>en {ligues.find(ligue => ligue.ligueId === Number(filters.ligueId))?.ligueLib} • </>
                ) : 'en France • '}
                {selectedCategories.length > 0 && (
                  <>catégories : {selectedCategories.map(catId => categories.find(cat => cat.categorieId === catId)?.categorieLib).join(', ')} • </>
                )}
                {filters.epreuveId && (
                  <>épreuve : {epreuves.find(ep => ep.epreuveId === Number(filters.epreuveId))?.epreuveLib} • </>
                )}
                {filters.date && (
                  <>à partir du {new Date(filters.date).toLocaleDateString('fr-FR')}</>
                )}
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {currentTournois.map((tournoi) => {              
              const ligue = ligues.find(l => l.ligueId === tournoi.ligueId)?.ligueLib || 'N/A';
              const categorie = categories.find(c => c.categorieId === tournoi.categorieId)?.categorieLib || '';
              const epreuve = epreuves.find(e => e.epreuveId === tournoi.epreuveId)?.epreuveLib || '';
              return (
                <TournoiCard
                  key={tournoi.tournoiId}
                  tournoi={{
                    ...tournoi,
                    ligue,
                    categorie,
                    epreuve
                  }}
                />
              );
            })}
            </div>

          {/* Pagination */}
          <div className="mt-12 flex justify-center gap-4">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
            >
              ← Précédent
            </button>
            <span className="px-6 py-3 text-gray-700 font-semibold">
              Page {currentPage} sur {Math.ceil(filteredTournois.length / tournoisPerPage) || 1}
            </span>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(filteredTournois.length / tournoisPerPage)))}
              disabled={indexOfLastTournoi >= filteredTournois.length}
              className="px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:from-orange-600 hover:to-orange-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
            >
              Suivant →
            </button>
          </div>
        </div>
        
    </div>
      <Footer />
    </div>
  );
};

export default Tournois;
